import { render, staticRenderFns } from "./LaunchGame.vue?vue&type=template&id=0a773f86&scoped=true&"
import script from "./LaunchGame.vue?vue&type=script&lang=js&"
export * from "./LaunchGame.vue?vue&type=script&lang=js&"
import style0 from "./LaunchGame.vue?vue&type=style&index=0&id=0a773f86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a773f86",
  null
  
)

export default component.exports